import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    operatorsDropdownContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
}));
